export default __webpack_public_path__ + "static/media/element-ht.403a803d.png";